<div class="kz-annuaire-head">
  <button buttonContext="dark" class="kz-annuaire-head-go-back" [routerLink]="noBoxRoute" queryParamsHandling="preserve" kzButton *ngIf="bannerType == 'pro-box'">
    <span>
      <kz-icons name="arrowleft"></kz-icons>
        <span i18n="@@pro.listing.goBack">Go back</span>
    </span>
  </button>
  <app-picture-source
    [imgSrc]="'/assets/images/annuaire/banner-'+bannerType+'.jpg'"
    [presets]="'pro-banner' | imgPreset"
    [alt]="alt"
    [imgFit]="true"
    [mediaQueries]="[
      {mediaQuery: '(min-width: 421px) and (max-width: 767px)', settings: 'pro-banner' | imgPreset : 'md' },
      {mediaQuery: '(max-width: 420px)', settings: 'pro-banner' | imgPreset : 'xs'}
    ]"
    useLazyLoad="false"
    handleX2="true"
    preloadImages="true"
  ></app-picture-source>
  <ng-container  *ngIf="bannerType=='pro'" >
    <h1 class="kz-annuaire-head-title">
      <span *ngIf="!style && !jobType && !city && listingType == 'pros'" i18n="@@pro.listing.title">Professionals of decoration</span>
      <span *ngIf="style && !jobType && !city && listingType == 'pros'" i18n="@@pro.listing.title.style">Professionals of decoration style {{style.name}}</span>

      <span *ngIf="!style && !jobType && city && listingType == 'pros'" i18n="@@pro.listing.title.city">Professionals of decoration at {{city}}</span>
      <span *ngIf="style && !jobType && city && listingType == 'pros'" i18n="@@pro.listing.title.city-style">Professionals of decoration style {{style.name}} at {{city}}</span>

      <span *ngIf="!style && !city && jobType == 'interior-decorator'" i18n="@@pro.listing-interior-decorator.title">Interior designer</span>
      <span *ngIf="style  && !city && jobType == 'interior-decorator'" i18n="@@pro.listing-interior-decorator.title.style">Interior designer style {{style.name}}</span>

      <span *ngIf="!style && city && jobType == 'interior-decorator'" i18n="@@pro.listing-interior-decorator.title.city">Interior designer at {{city}}</span>
      <span *ngIf="style && city && jobType == 'interior-decorator'" i18n="@@pro.listing-interior-decorator.title.city-style">Interior designer style {{style.name}} at {{city}}</span>

      <span *ngIf="!style && !city && jobType == 'interior-architect'" i18n="@@pro.listing-interior-architect.title">Interior architects</span>
      <span *ngIf="style && !city && jobType == 'interior-architect'" i18n="@@pro.listing-interior-architect.title.style">Interior architects style {{style.name}}</span>

      <span *ngIf="!style && city && jobType == 'interior-architect'" i18n="@@pro.listing-interior-architect.title.city">Interior architects at {{city}}</span>
      <span *ngIf="style && city && jobType == 'interior-architect'" i18n="@@pro.listing-interior-architect.title.city-style">Interior architects style {{style.name}} at {{city}}</span>

      <span *ngIf="!type && listingType == 'pro-services'" i18n="@@pro.listing-offers.title">decoration services</span>
      <span *ngIf="type && listingType == 'pro-services'" i18n="@@pro.listing-offers.title.type">{{type.name}} decoration services</span>

      <strong i18n="@@pro.listing.description">for an interior that looks like you</strong>
    </h1>
  </ng-container>

  <h1 *ngIf="bannerType=='pro-box'" class="kz-annuaire-head-title--box">
    <ng-container i18n="@@pro.listing.box.title.style">Discover a <span>decoration coaching</span> experience</ng-container>
  </h1>
</div>
